import React from 'react';

export const NavHeader = () => (
  <nav className="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
    <a className="navbar-brand" href="#">React Custom Tabs</a>
    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"/>
    </button>

  </nav>
);



// WEBPACK FOOTER //
// ./src/components/navHeader.jsx